var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63466 4.1125L2.34199 3.45L6.19466 7.06063C6.25676 7.11848 6.30605 7.18728 6.33968 7.26306C6.37331 7.33884 6.39063 7.42011 6.39063 7.50219C6.39063 7.58427 6.37331 7.66554 6.33968 7.74132C6.30605 7.8171 6.25676 7.8859 6.19466 7.94375L2.34199 11.5563L1.63532 10.8938L5.25132 7.50313L1.63466 4.1125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.89095949f559bb074bf6547cd5cd49d4.svg";
export { ForwardRef as ReactComponent };